import { CSSProperties } from 'react';
import { sum } from 'lodash';
import { business_1100, grey_700 } from '@fiverr-private/sass/helpers';
import { AvatarProps } from './types';
import { AVATAR_BACKGROUND_COLORS, ROUNDED_FULL } from './constants';

export const getAvatarBackgroundColor = ({
    color,
    username,
}: {
    color: AvatarProps['color'];
    username: AvatarProps['username'];
}) => {
    if (username && color === 'auto') {
        const supportedBackgroundColors = Object.keys(AVATAR_BACKGROUND_COLORS);
        const usernameInAscii = sum(username.split('').map((char) => char.charCodeAt(0)));
        const colorIndex = usernameInAscii % supportedBackgroundColors.length;
        return AVATAR_BACKGROUND_COLORS[supportedBackgroundColors[colorIndex]];
    }

    if (color) {
        return AVATAR_BACKGROUND_COLORS[color];
    }

    return grey_700;
};

export const getRingStyle = ({ showRing, ringSize }: { showRing: AvatarProps['showRing']; ringSize: number }) => {
    const style: CSSProperties = {
        borderRadius: ROUNDED_FULL,
    };

    if (showRing) {
        style.border = `${ringSize}px solid ${business_1100}`; // This is the actual ring
        style.padding = `${ringSize}px`; // push away from the avatar itself to create an illusion of a ring
    }

    return style;
};
